import { Box, Button, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import { ReactComponent as EyeIcon } from '../../assets/icons/main/eye-icon.svg';
import { ReactComponent as EyeOffIcon } from '../../assets/icons/main/eye-off-icon.svg';
import { useTheme } from "@emotion/react";
import { useState, FC } from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import Snackbar from "../../common/snackBar";
import CopyIcon from '@mui/icons-material/ContentCopy';

interface SecretDetailsProps {
    secret_id: string;
    secretKeyData: { key: string; value: string; showValue: boolean }[];
    readSecrets: (id: string) => void;
    hideSecrets: (id: string) => void;
}

const SecretDetails: FC<SecretDetailsProps> = ({ secret_id, secretKeyData, readSecrets, hideSecrets }) => {
    const theme:any = useTheme();
    const [showValue, setShowValue] = useState<boolean>(true);

    const styles = {
        title: {
            color: theme.palette.text.primary,
            display: 'flex',
            justifyContent: 'start',
            padding: '13px 24px',
        },
        titleGrid: {
            borderRight: `1px solid ${theme.palette.customBorderColor.main}`,
            borderLeft: `1px solid ${theme.palette.customBorderColor.main}`,
        },
    };

    const handleToggleVisibility = () => {
        if (showValue) {
            readSecrets(secret_id);
        } else {
            hideSecrets(secret_id);
        }
        setShowValue(!showValue);
    };

    return (
        <Box>
            <Grid textAlign="right" sx={{ paddingY: '16px' }}>
                <Button
                    variant={showValue ? 'outlined' : 'outlined'}
                    color="primary"
                    sx={{width:'151px'}}
                    onClick={handleToggleVisibility}
                    startIcon={showValue ? <EyeIcon  /> : <EyeOffIcon />}
                >
                    {showValue ? 'Show All' : 'Hide All'}
                </Button>
            </Grid>
            <Grid
                container
                direction="row"
                sx={{
                    borderTop: `1px solid ${theme.palette.customBorderColor.main}`,
                    borderBottom: `1px solid ${theme.palette.customBorderColor.main}`,
                }}
            >
                {secretKeyData.length ? (
                    secretKeyData.map((row, index) => (
                        <Grid
                            container
                            key={`sec_${index}`}
                            sx={{
                                borderBottom:
                                    index !== secretKeyData.length - 1
                                        ? `1px solid ${theme.palette.customBorderColor.main}`
                                        : 'none',
                            }}
                        >
                            <Grid item xs={4} sm={3.5} md={2.5} lg={1.75} xl={1.25} sx={styles.titleGrid}>
                                <Typography variant="subtitle1" sx={styles.title}>
                                    {row.key}
                                </Typography>
                            </Grid>
                            <Grid
                                item
                                xs={8}
                                sm={8.5}
                                md={9.5}
                                lg={10.25}
                                xl={10.75}
                                sx={{
                                    padding: '13px 16px',
                                    borderRight: `1px solid ${theme.palette.customBorderColor.main}`,
                                }}
                            >
                                <Box display="flex" alignItems="center" sx={{ width: 'auto' }}>
                                    {row.showValue ? (
                                        <Tooltip
                                          title={
                                            <CopyToClipboard
                                              text={row.value}
                                              onCopy={() => {
                                                Snackbar.info('Copied!');
                                              }}
                                            >
                                              <IconButton
                                                sx={{
                                                  padding: 0,
                                                  color: '#fff',
                                                  fontSize: 16,
                                                  '&.MuiIconButton-root:hover': {
                                                    backgroundColor: 'transparent !important',
                                                    textDecoration: 'none',
                                                  },
                                                }}
                                              >
                                                <CopyIcon sx={{ color: '#fff', mr: '4px' }} /> Copy
                                              </IconButton>
                                            </CopyToClipboard>
                                          }
                                          arrow
                                          placement='top'
                                        >
                                          <Typography
                                            variant='subtitle1'
                                            sx={{
                                              color: theme.palette.text.primary,
                                              overflow: 'hidden',
                                              maxWidth: 'calc(100vw - 470px)',
                                              textOverflow: 'ellipsis',
                                            }}
                                          >
                                            {row.value}
                                          </Typography>
                                        </Tooltip>
                                    ) : (
                                        <Typography variant="subtitle1" sx={{ color: theme.palette.text.primary }}>
                                            **********
                                        </Typography>
                                    )}
                                </Box>
                            </Grid>
                        </Grid>
                    ))
                ) : (
                    <Typography variant="subtitle1" sx={{ padding: '16px' }}>
                        No Data
                    </Typography>
                )}
            </Grid>
        </Box>
    );
};

export default SecretDetails;
